import { matchPath } from "react-router-dom";

// Mirrors the client-view subtree in App.tsx, written in top-level form: these
// are the paths that exist both at the root and under /client-view/:userId.
const CLIENT_VIEW_ROUTES = [
  "/account-settings",
  "/user-management",
  "/chat",
  "/integrations",
  "/integrations/:id",
  "/data-storage",
  "/partners",
  "/partners/:slug",
  "/secure-exchange",
  "/secure-exchange/clients/:clientId",
  "/secure-exchange/clients/:clientId/projects/:projectId",
  "/secure-exchange/clients/:clientId/projects/:projectId/collections/:collectionId",
  "/secure-file-upload",
  "/sftp-management",
  "/sftp-management/:id",
  "/partner-management",
  "/integrations-beta",
  "/integrations-beta/:id",
  "/bots-management",
  "/bots-management/:id",
  "/bots-management/:id/connections",
  "/bots-management/:id/major-job/:majorJobId",
  "/bots-management/:id/major-job/:majorJobId/split-job/:splitJobId",
  "/bots-management/:id/:connectionId",
  "/bots-management/:id/:connectionId/task/:taskId",
];

// Mounted at the root only. Pushing these under the shell would hit the
// catch-all route, which redirects to "/" and so leaves client view.
const TOP_LEVEL_ONLY = [
  "/integrations-beta/register",
  "/bots-management/:id/major-jobs",
];

export function isClientViewRoute(path: string): boolean {
  const pathname = path.split("?")[0].split("#")[0];
  if (TOP_LEVEL_ONLY.some((pattern) => matchPath(pattern, pathname))) {
    return false;
  }
  return CLIENT_VIEW_ROUTES.some((pattern) => matchPath(pattern, pathname));
}

/**
 * Keeps an app path inside the current shell: prefixes it with basePath while
 * client view is active, and leaves alone anything that has no twin under the
 * shell or is already prefixed.
 */
export function withShell(basePath: string, path: string): string {
  if (!basePath) return path;
  if (!path || path === "/") return basePath;
  if (path === basePath || path.startsWith(`${basePath}/`)) return path;
  return isClientViewRoute(path) ? `${basePath}${path}` : path;
}
